import CaseStudyCard from "../../reusables/CaseStudyCard";
import hana from "../../../assets/images/case-studies/hanasafaris.jpg";

const HanaSafarisCaseStudyCard = () => {
  return (
    <CaseStudyCard
      brand={hana}
      client="HANA SAFARIS"
      solution="Brand Transformation"
      title="The transformation of a distinctive safari concept to The Home of Uganda’s Five Giants™"
      subtitle="How we translated a safari concept into a professional brand and a world-class digital experience"
      link="/case-studies/hanasafaris"
    >
      <li>
        ✔︎ <span>Logo design</span>
      </li>
      <li>
        ✔︎ <span>Brand identity</span>
      </li>
      <li>
        ✔︎ <span>Social media re-setup</span>
      </li>
      <li>
        ✔︎ <span>Website development</span>
      </li>
      <li>
        ✔︎ <span>Digital presence re-launch</span>
      </li>
    </CaseStudyCard>
  );
};

export default HanaSafarisCaseStudyCard;
